module.exports = __webpack_public_path__ + "img/DataSpell_icon.291c1c67.png";